import { SectionSwitcher } from "../../../jobs-flow/SectionSwitcher";

export const PaymentMethodInterface = {
    setAsPrimary() {
        $.ajax({
            method: 'PATCH',
            url: `${this.urlRoot}/${this.id}/set-primary`,
            success: () => {
                SectionSwitcher.updateSection('paymethods');
                setTimeout(() => window.location.reload(), 500)
            }
        });
    },

    setAsBackup() {
        $.ajax({
            method: 'PATCH',
            url: `${this.urlRoot}/${this.id}/set-backup`,
            success: () => {
                SectionSwitcher.updateSection('paymethods');
                setTimeout(() => window.location.reload(), 500)
            }
        });
    }
}
